import React from 'react';

const FloatingInstagramButton: React.FC = () => {
  const href = 'https://www.instagram.com/trattyprofessionals';
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Abrir Instagram"
      className="floating-social-btn floating-instagram-btn"
      onClick={() => {
        import('../utils/analytics').then(m => m.trackClickInstagram()).catch(() => {});
      }}
    >
      <i className="bi bi-instagram" aria-hidden="true"></i>
    </a>
  );
};

export default FloatingInstagramButton;
